/**
 * Mosaic Carousel — Embla on mobile (≤550px), destroyed on wider viewports.
 *
 * Handles multiple .z-image-mosaic blocks on one page independently.
 * Uses matchMedia so Embla is only active at the mobile breakpoint;
 * resizing to desktop destroys the instance and restores the CSS grid.
 */
(function () {
  'use strict';

  var BREAKPOINT = '(max-width: 550px)';

  document.addEventListener('DOMContentLoaded', function () {
    var mosaics = document.querySelectorAll('.z-image-mosaic');
    if (!mosaics.length) return;

    mosaics.forEach(initMosaic);
  });

  function initMosaic(mosaic) {
    // Only activate Embla when the block has carousel mode enabled.
    if (!mosaic.classList.contains('z-image-mosaic--carousel')) return;

    var viewport = mosaic.querySelector('.z-image-mosaic__viewport');
    var dotsWrap = mosaic.querySelector('.z-image-mosaic__dots');
    var prevBtn  = mosaic.querySelector('.z-image-mosaic__prev');
    var nextBtn  = mosaic.querySelector('.z-image-mosaic__next');

    if (!viewport || !dotsWrap || !prevBtn || !nextBtn) return;

    var embla = null;
    var dots  = [];

    // ── Embla lifecycle ────────────────────────────────────────────────────

    function buildDots() {
      dotsWrap.innerHTML = '';
      dots = [];

      embla.scrollSnapList().forEach(function (_, index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.classList.add('z-image-mosaic__dot');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        btn.addEventListener('click', function () {
          embla.scrollTo(index);
        });
        dotsWrap.appendChild(btn);
        dots.push(btn);
      });
    }

    function updateDots() {
      var selected = embla.selectedScrollSnap();
      dots.forEach(function (dot, i) {
        var active = i === selected;
        dot.classList.toggle('is-selected', active);
        dot.setAttribute('aria-selected', String(active));
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function onPrev() { embla.scrollPrev(); }
    function onNext() { embla.scrollNext(); }

    function mount() {
      if (embla) return;

      embla = EmblaCarousel(viewport, {
        loop:  true,
        align: 'start',
      });

      buildDots();
      updateDots();

      embla.on('select', updateDots);
      embla.on('reInit', buildDots);
      embla.on('reInit', updateDots);

      prevBtn.addEventListener('click', onPrev);
      nextBtn.addEventListener('click', onNext);
    }

    function unmount() {
      if (!embla) return;

      prevBtn.removeEventListener('click', onPrev);
      nextBtn.removeEventListener('click', onNext);

      embla.destroy();
      embla = null;

      dotsWrap.innerHTML = '';
      dots = [];
    }

    // ── Breakpoint watcher ─────────────────────────────────────────────────

    var mq = window.matchMedia(BREAKPOINT);

    function onBreakpoint(e) {
      if (e.matches) {
        mount();
      } else {
        unmount();
      }
    }

    // matchMedia.addEventListener is the modern API; addListener is legacy (Safari <14).
    if (mq.addEventListener) {
      mq.addEventListener('change', onBreakpoint);
    } else {
      mq.addListener(onBreakpoint);
    }

    // Run immediately on page load.
    onBreakpoint(mq);
  }
})();
